module.exports = __webpack_public_path__ + "media/images/lb/055-7c4d460abb1250cac15a13867e2deb82.svg";